import RFFInputField from '../../form/RFFInputField';
import RFFNumberInputField from '../../form/RFFNumberInputField';

// import RFFSelectField from '../../form/RFFSelect';
import RFFSelectCountryField from '../../form/RFFSelectCountry';
import RFFSelectStateProvField from '../../form/RFFSelectSateProv';

import msgs from '../../../config/messages';
// import State from '../../../config/fiftyStates.json';
import {
  required,
  isCageCode,
  // isCanadianZipCode,
  // isUSZipCode,
} from '../../../utils/validationUtils';



// const createOptions = obj => {
//   const keys = Object.keys(obj);

//   const options = keys.map(key => ({ text: obj[key], value: key }));
//   return options;
// };

// only put disabled info to override the default (SAM.gov => disabled otherwise enabled)
export const orgDetailsConfig = [
  {
    name: 'cageCode',
    label: msgs.OrganizationForm.cageCode,
    component: RFFInputField,
    isRequired: true,
    disabled: true,
    validate: isCageCode,
    type: 'text',
  },
  {
    name: 'address1',
    label: msgs.OrganizationForm.address1,
    component: RFFInputField,
    isRequired: true,
    validate: required,
  },
  {
    name: 'address2',
    label: msgs.OrganizationForm.address2,
    component: RFFInputField,
  },
  {
    name: 'address3',
    label: msgs.OrganizationForm.address3,
    component: RFFInputField,
  },
  {
    name: 'city',
    label: msgs.OrganizationForm.city,
    component: RFFInputField,
    isRequired: true,
    validate: required,
  },
  {
    name: 'cntry',
    label: 'Country',
    component: RFFSelectCountryField,
    isRequired: true,
    // disabled: true,
    validate: required,
  },
  {
    name: 'state',
    label: msgs.OrganizationForm.state,
    component: RFFSelectStateProvField,
    isRequired: true,
    validate: required,
    // options: createOptions(State),
  },

  {
    name: 'zipCode',
    label: msgs.OrganizationForm.zipcode,
    component: RFFInputField,
    isRequired: true,
    validate: required,
  },

  {
    name: 'websiteUrl',
    label: msgs.OrganizationForm.websiteUrl,
    component: RFFInputField,
    isRequired: true,
    validate: required,
  },
];

export const contactConfig = [
  {
    name: 'pointOfContact',
    label: 'Full Name',
    component: RFFInputField,
    // disabled: true,
    // isRequired: true,
    // validate: required,
  },
  {
    name: 'email',
    label: 'Email',
    component: RFFInputField,
    // disabled: false,
    // isRequired: true,
    // validate: composeValidators(required, isEmail, emailIsValidAndUnsassigned),
  },
  {
    name: 'phoneNumber',
    label: 'Phone',
    component: RFFNumberInputField,
    // disabled: true,
    // isRequired: true,
    // validate: composeValidators(required, isPhoneNumber),
  },
];



// WEBPACK FOOTER //
// ./src/components/forms/EditOrganizationForm/formConfig.jsx